import{Component,OnDestroy,OnInit,ViewChild,AfterViewInit}from"@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable, Subject, Subscription } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import * as fromTask from "../../task-state/reducers/task.reducer";
import * as Task from "./../../../superTask/task-state/actions/task.actions";
import { PetitionerService } from "src/app/services/petitioner.service";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import{getSubTaskDetails,getSubTaskStepList,loadSubTaskDetails,SetVisaTypeCode,getStepStatusUpdate,getSuperTask,SetFormCreationType,SetDataSourceCountryList}from"visa-store";
import{TaskStep,SubTaskDetails,SubTask,ImagilityBaseResponse,PrimaryData,SuperTask,TaskSummaryOverview}from"app-models";
import { LookupService } from "src/app/services/lookup-data.service";
import { getSubTaskList } from "src/app/modules/superTask/task-state/reducers/task.reducer";
import { CustomQuestionnaireService } from "src/app/modules/custom-questionaire/services/custom-questionnaire.service";
import { LockUnlockStepsLibraryService } from "lock-unlock-steps-library";
import { ToastrService } from "ngx-toastr";
import { ReferenceLibraryService } from "reference-library";
import { MainContainerComponentService } from "src/app/modules/l1-visa/components/main-container/main-container.component.service";
import { TaskNotesService } from "task-notes-lib";
import { MatDialog } from "@angular/material/dialog";
import { CustomStepsComponent } from "src/app/modules/l1-visa/components/custom-steps/custom-steps.component";

import { layout_code } from "src/app/modules/l1-visa/utility/constants/layout-code";
import { SendNotificationComponent } from "send-notification";
import { LcaComponent } from "src/app/modules/compliance/lca/lca.component";
import { EducationDetailsComponent } from "src/app/modules/immigration-wizard/education-details/education-details.component";
import { ItineraryOfServicesComponent } from "src/app/modules/immigration-wizard/itinerary-of-services/itinerary-of-services.component";
import { JobDescriptionComponent } from "src/app/modules/immigration-wizard/job-description/job-description.component";
import { UscisContentComponent } from "src/app/modules/l1-visa/components/uscis-content/uscis-content.component";
import { AwaitLotterySelectionComponent } from "src/app/modules/l1-visa/components/await-lottery-selection/await-lottery-selection.component";
import { BeneficiaryDocumentsComponent } from "src/app/modules/l1-visa/components/beneficiary-documents/beneficiary-documents.component";
import { BeneficiaryPersonalDetailsComponent } from "src/app/modules/l1-visa/components/beneficiary-personal-details/beneficiary-personal-details.component";
import { CaptureExtraordinaryAbilityDetailsComponent } from "src/app/modules/l1-visa/components/capture-extraordinary-ability-details/capture-extraordinary-ability-details.component";
import { CustomStepsFormComponent } from "src/app/modules/l1-visa/components/custom-steps-form/custom-steps-form.component";
import { EfilingComponent } from "src/app/modules/l1-visa/components/efiling/efiling.component";
import { EnterEntitiesRelationshipDetailsComponent } from "src/app/modules/l1-visa/components/enter-entities-relationship-details/enter-entities-relationship-details.component";
import { EnterProcessingInformationComponent } from "src/app/modules/l1-visa/components/enter-processing-information/enter-processing-information.component";
import { GetReceiptsComponent } from "src/app/modules/l1-visa/components/get-receipts/get-receipts.component";
import { H1bJobDescriptionComponent } from "src/app/modules/l1-visa/components/h1b-job-description/h1b-job-description.component";
import { H1bPetitionerDetailsComponent } from "src/app/modules/l1-visa/components/h1b-petitioner-details/h1b-petitioner-details.component";
import { IndividualsDetailsComponent } from "src/app/modules/l1-visa/components/individuals-details/individuals-details.component";
import { LcaAndJobDetailsComponent } from "src/app/modules/l1-visa/components/lca-and-job-details/lca-and-job-details.component";
import { LetterGenerationComponent } from "src/app/modules/l1-visa/components/letter-generation/letter-generation.component";
import { PastJobDescriptionComponent } from "src/app/modules/l1-visa/components/past-job-description/past-job-description.component";
import { PetitionerDetailsForeignCompanyComponent } from "src/app/modules/l1-visa/components/petitioner-details-foreign-company/petitioner-details-foreign-company.component";
import { PetitionerDetailsComponent } from "src/app/modules/l1-visa/components/petitioner-details/petitioner-details.component";
import { PrintPetitionComponent } from "src/app/modules/l1-visa/components/print-petition/print-petition.component";
import { ProvideEERComponent } from "src/app/modules/l1-visa/components/provide-eer/provide-eer.component";
import { ProvideInformationContainerComponent } from "src/app/modules/l1-visa/components/provide-information-container/provide-information-container.component";
import { ReviewI140PetitionComponent } from "src/app/modules/l1-visa/components/review-i140-petition/review-i140-petition.component";
import { SpecialityOccupationComponent } from "src/app/modules/l1-visa/components/speciality-occupation/speciality-occupation.component";
import { SubmitPetitionComponent } from "src/app/modules/l1-visa/components/submit-petition/submit-petition.component";
import { UpdateDecisionComponent } from "src/app/modules/l1-visa/components/update-decision/update-decision.component";
import { UpdateDeterminationComponent } from "src/app/modules/l1-visa/components/update-determination/update-determination.component";
import { USCISH1BLotteryComponent } from "src/app/modules/l1-visa/components/uscis-h1-b-lottery/uscis-h1-b-lottery.component";
import { VdApplicantDetailsComponent } from "src/app/modules/l1-visa/components/vd-applicant-details/vd-applicant-details.component";
import { VdJobDescriptionComponent } from "src/app/modules/l1-visa/components/vd-job-description/vd-job-description.component";
import { VdProvidePetitionerDetailsComponent } from "src/app/modules/l1-visa/components/vd-provide-petitioner-details/vd-provide-petitioner-details.component";
import { WorkExperienceDetailsComponent } from "src/app/modules/l1-visa/components/work-experience-details/work-experience-details.component";
import { UpdateEmploymentComponent } from "src/app/modules/update-employment/update-employment.component";

@Component({
  selector: "app-timeline-step",
  templateUrl: "./timeline-step.component.html",
  styleUrls: ["./timeline-step.component.scss"],
})
export class TimelineStepComponent implements OnInit, AfterViewInit {
  dynamicDialogRef: DynamicDialogRef;
  primaryData: any;
  stepList = [];
  receiptETADateRange: string;
  decisionETADateRange: string;
  selectedTaskType;
  taskStatus: string = "INPROGRESS";

  observableSubscription$ = new Subject();
  subTaskLoaded$ = new Subject();  
  subTaskList: SubTask[];
  superTask: SuperTask;
  task: SubTaskDetails;
  SubTaskStepList: any;
  subTaskDetails: SubTaskDetails;
  isSimplifyData: boolean;
  taskTypeCode: string;
  taskType: string;
  caseId: number;
  paramTaskTypeCode: string;
  superTaskTypeCode: string;
  visaTypeName: string;
  customStepsFromOveriew: any;
  beneficiaryDetails: any = {};
  taskLevelData: any;
  taskAllocationUpdated: boolean;
  visaTypeArray = ["L1A", "L1B", "E1", "E2", "E2C", "TN1", "TN2", "H1-B"];
  OVisaTypeArray = ["O1A", "O1B"];
  isBeneficiaryInitiate;

  constructor(
    public dialog: MatDialog,
    public dialogService: DialogService,
    public petitionerService: PetitionerService,
    private lookupService: LookupService,
    private route: ActivatedRoute,
    public toastr: ToastrService,
    private mainContainerComponentService: MainContainerComponentService,
    private taskNotesService: TaskNotesService,
    private customQuestionnaireService: CustomQuestionnaireService,
    private lockUnlockStepsLibraryService: LockUnlockStepsLibraryService,
    private referenceLibraryService: ReferenceLibraryService,
    private store: Store<fromTask.State>
  ) {}

  ngOnInit(): void {
    this.lookupService.isBeneficiaryInitiate.pipe(takeUntil(this.observableSubscription$)).subscribe(val => {;this.isBeneficiaryInitiate = val})
    const benData = JSON.parse(sessionStorage.getItem('beneficiaryId'));
    const companyId = parseInt(sessionStorage.getItem('companyId'));
    //set companyId to new variable for Notes feature, current one is overriding based on existing conditions
    sessionStorage.setItem('noteCompanyId', sessionStorage.getItem('companyId'));
    if (sessionStorage.getItem('taskDetailsList') && !isNaN(companyId) && !isNaN(benData)) {
      const taskData = JSON.parse(sessionStorage.getItem('taskDetailsList'));
      this.petitionerService.getTaskLevelData(taskData[0].taskTypeId, companyId, benData).subscribe((element) => {
        this.taskLevelData = {
          "taskTypeId": element.taskTypeId,
          "companyId": element.companyId,
          "taskType": element.taskType,
          "taskTypeCd": element.taskTypeCd,
          "visaType": element.visaType,
          "visaTypeCd": element.visaTypeCd,
          "petitionType": element.petitionType,
          "petitionTypeCd": element.petitionTypeCd,
          "subTaskType": element.subTaskType,
          "subTaskTypeCd": element.subTaskTypeCd,
          "visaTemplateCode": element.visaTemplateCode,
          "id": element.beneficiaryId, // beneficiary id
          "beneficiaryName": element.beneficiaryName
        };
        this.beneficiaryDetails.beneficiaryEmployeeId = element.beneficiaryId;
      });
    } 
    
    this.stepList = [];
    
    this.store
      .pipe(select(getSuperTask))
      .pipe(take(1))
      .subscribe((data: SuperTask) => {
        this.superTask = data;       
        this.postNgOnInit();
      });     
   
  }

  postNgOnInit(){    
    // Get Specific Task Details
    this.store
      .select(getSubTaskDetails)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: SubTaskDetails) => {  
        if (data?.id || this.taskTypeCode) {                    
          this.task = data;
          this.paramTaskTypeCode = data.subTaskTypeCode;      
          this.subTaskDetails = data;
          //console.log('taskssss', this.subTaskDetails);
          const simplifyData: any = this.subTaskDetails.taskTypeDetails;
          //console.log('taskssss11', simplifyData);
          if (simplifyData && simplifyData.version == 'CWF') {
            //console.log('taskssss22', simplifyData.version);
            this.isSimplifyData = true;
            sessionStorage.setItem("isSimplify", simplifyData.version);
          } else {
            this.isSimplifyData = false;
            sessionStorage.setItem("isSimplify", 'false');
          }
          sessionStorage.setItem(
            "taskTypeId",
            JSON.parse(JSON.stringify(this.subTaskDetails.taskTypeId))
          );
          if (this.route.snapshot.paramMap.has("visaType")) {
            this.taskType = this.task.taskTypeDetails.visaType
              ? this.task.taskTypeDetails.visaType
              : this.task.taskTypeDetails.immCategoryCode;
          } else if (this.route.snapshot.paramMap.has("taskType")) {
            this.taskType = this.route.snapshot.paramMap.get("taskType");
          }
          this.receiptETADateRange = data.receiptETADateRange;
          this.decisionETADateRange = data.decisionETADateRange;
          this.store.dispatch(
            new Task.SetActiveSubTaskIndex(this.subTaskDetails?.id)
          );
          let familyId;
          if (
            ["K1", "K3"].includes(
              this.subTaskDetails.taskTypeDetails.visaType
            ) &&
            this.subTaskDetails.jsonInput
          ) {
            const jsonInput = JSON.parse(this.subTaskDetails.jsonInput);
            familyId =
              jsonInput &&
                jsonInput.primaryApplicant &&
                jsonInput.primaryApplicant?.id
                ? jsonInput.primaryApplicant?.id
                : null;
          } else {
            familyId = this.subTaskDetails.familyId
              ? this.subTaskDetails.familyId
              : null;
          }
          this.primaryData = {
            superTaskId: this.subTaskDetails.superTaskId,
            subTaskId: this.subTaskDetails?.id,
            caseType: this.taskTypeCode,
            caseId: this.caseId || this.subTaskDetails.petitionId,
            petitionId: this.subTaskDetails.petitionId,
            foreignCompanyId: this.subTaskDetails.foreignCompanyId,
            visatype:
              this.paramTaskTypeCode === "I130"
                ? "GC"
                : this.subTaskDetails.taskTypeDetails.visaType
                  ? this.subTaskDetails.taskTypeDetails.visaType
                  : this.subTaskDetails.taskTypeDetails.immCategoryCode,
            visaName: this.subTaskDetails.taskTypeDetails.visaName,
            petitionType: this.subTaskDetails.taskTypeDetails.petitionType,
            immSpecialistId: this.subTaskDetails.immSpecialistId,
            attorneyId: this.subTaskDetails.attorneyId,
            sponsorId: ["K1", "K3"].includes(
              this.subTaskDetails.taskTypeDetails.visaType
            )
              ? this.subTaskDetails.beneficiaryId
              : this.subTaskDetails.sponsorId
                ? this.subTaskDetails.sponsorId
                : null,
            familyId,
            isBeneficiaryInitiate: this.isBeneficiaryInitiate,
            immigrationCategory:
              this.paramTaskTypeCode === "I130"
                ? "GC"
                : this.superTask && this.superTask.immigrationCategory
                  ? this.superTask.immigrationCategory.code
                  : null,
            immigrationCategoryName:
              this.superTask && this.superTask.immigrationCategory
                ? this.superTask.immigrationCategory.name
                : null,
            immigrationClassification:
              this.superTask && this.superTask.immigrationClassification
                ? this.superTask.immigrationClassification.code
                : null,
            immigrationClassificationName:
              this.superTask && this.superTask.immigrationClassification
                ? this.superTask.immigrationClassification.name
                : null,
            superTaskTypeCode: this.superTaskTypeCode,
            getTaskType:
              this.superTaskTypeCode === "NONIMMPET"
                ? this.subTaskDetails.taskTypeDetails.visaType
                : this.taskTypeCode,
            jsonInput: this.subTaskDetails.jsonInput
              ? JSON.parse(this.subTaskDetails.jsonInput)
              : null,
            beneficiaryId: this.subTaskDetails.beneficiaryId
              ? this.subTaskDetails.beneficiaryId
              : sessionStorage.getItem('beneficiaryId'),
            relationshipCode: this.subTaskDetails.relationshipCode
              ? this.subTaskDetails.relationshipCode
              : null,
            taskTypeId: this.subTaskDetails.taskTypeId || null,
            taskTypeSaveJsonId: this.subTaskDetails.taskTypeSaveJsonId || null,
            filingType:this.subTaskDetails.filingType || null
          };
          this.subTaskLoaded$.next(true);          
        }
      });

     // Get sub task list
     this.store
     .pipe(select(getSubTaskList))
     .pipe(takeUntil(this.observableSubscription$))
     .subscribe((data: SubTask[]) => {
       setTimeout(() => {
         if (data && data.length > 0) {
           this.visaTypeName = data[0].visaTypeName;
           this.customStepsFromOveriew = data[0].customStepOverviewList
             ? data[0].customStepOverviewList
             : [];
             const subTask = data[0];
          //  const subTask = data.find(
          //    (x) => x.taskTypeCode === this.paramTaskTypeCode
          //  );
          this.caseId = subTask.caseId;
          this.taskTypeCode = subTask.taskTypeCode;
          this.superTaskTypeCode = subTask.superTaskTypeCode;
 
           this.store.dispatch(
             new SetVisaTypeCode(
               this.superTaskTypeCode === "NONIMMPET"
                 ? this.superTask.visaType.code
                 : this.taskTypeCode
             )
           );
           this.store.dispatch(
             new SetFormCreationType(
               subTask.formCreationType && subTask.formCreationType.code
                 ? subTask.formCreationType.code
                 : null
             )
           );
           this.store.dispatch(
             loadSubTaskDetails({
               taskId: parseInt(subTask?.id.toString()),
               // visaTypeCode: this.route.snapshot.paramMap.get(this.paramPresent)
               visaTypeCode:
                 this.superTaskTypeCode === "NONIMMPET"
                   ? this.superTask.visaType.code
                   : this.taskTypeCode,
             })
           );
 
         }
       }, 1000);
     });

     this.subTaskLoaded$
    .pipe(takeUntil(this.observableSubscription$))
    .subscribe((val) => {      
      // Get Step list 
      this.store
        .pipe(select(getSubTaskStepList))        
        .pipe(take(1))
        .subscribe((data: TaskStep[]) => {
          if (data) {
            this.SubTaskStepList = JSON.parse(JSON.stringify(data));
            this.checkForTaskAllocationUpdate(data);
            // if(this.taskAllocationUpdated){
            setTimeout(() => {
              this.refreshCustomStepListing(data);
            }, 3000);
            // }
          }
        });
      // Get Step list
    });

      this.store
      .pipe(select(getStepStatusUpdate))
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: ImagilityBaseResponse) => {
        if (response && response.status === 200) {
          this.toastr.success(response.message);
          this.mainContainerComponentService.onStepStatusUpdate(
            this.subTaskDetails.superTaskId
          );
        }
      });

      this.taskNotesService.onNotesUpdated
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(() => {
        this.mainContainerComponentService.onStepStatusUpdate(
          this.subTaskDetails.superTaskId
        );
      });

    this.lockUnlockStepsLibraryService.onlockedUpdated
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(() => {
        this.mainContainerComponentService.onStepStatusUpdate(
          this.subTaskDetails.superTaskId
        );
      });
    
  }

  handleStepClick(step: any) {
    document.getElementsByTagName('body')[0].classList.add('no-scroll');
    if (step.previousStepName != null) {
      const dialogRef = this.dialog.open(CustomStepsComponent, {
        disableClose: true,
        width: "100%",
        height: "100vh",
        panelClass: "custom-questionnaire-dialog-container",
        data: {
          stepName: step.stepName,
          taskId: step.taskId ? step.taskId : this.subTaskDetails?.id,
          subTaskDetails: this.subTaskDetails,
          stepId: step.stepId,
          beneficiaryId: this.superTask.beneficiaryId,
          isCustomStep: true,
        },
      });
      dialogRef.afterClosed().subscribe(() => {
        document.getElementsByTagName('body')[0].classList.remove('no-scroll');
        this.refreshStepListing();
      });
    } else {
      let companyId: any =
        this.subTaskDetails.createdByUserType === "Attorney"
          ? this.subTaskDetails.attorneyId
          : this.subTaskDetails.companyId;
      sessionStorage.setItem("companyId", companyId);
      sessionStorage.setItem("tempPetitionId", JSON.stringify(this.subTaskDetails.petitionId));
      this.primaryData = {
        ...this.primaryData,
        stepId: step?.id,
        companyId: step.companyId,
        petitionerId: step.petitionerId,
        stepName: step.stepName,
        layoutCode: step.stepActionList[0].layoutCode,
        taskId: step.taskId,
        isCustomStep: false,
        individualStepId: step?.stepId,
      };
      if (sessionStorage.getItem('isSimplify') && sessionStorage.getItem('isSimplify') == 'CWF') {
        this.dynamicDialogRef = this.dialogService.open(
          this.getStepComponent(step.stepActionList[0].layoutCode),
          {
            width: "100%",
            contentStyle: {
              "max-height": "100vh",
              "z-index": "1000",
              "padding": "0px 7px 0px",
              "padding-bottom": "15px",
              "overflow-y": "auto !important",
            },
            closable: false,
            showHeader: false,
            closeOnEscape: false,
            modal: true,
            dismissableMask: true,
            data: this.primaryData,
          }
        );
      } else {
        this.dynamicDialogRef = this.dialogService.open(
          this.getStepComponent(step.stepActionList[0].layoutCode),
          {
            width: "100%",
            height: "100vh",
            contentStyle: {
              "max-height": "100vh",
              "z-index": "1000",
              "padding-bottom": "15px",
              "overflow-y": "hidden !important",
              "height": "100%"
            },
            closable: false,
            showHeader: false,
            closeOnEscape: false,
            modal: true,
            dismissableMask: true,
            data: this.primaryData,
          }
        );
      }

      this.dynamicDialogRef.onClose.subscribe(() => {
        document.getElementsByTagName('body')[0].classList.remove('no-scroll');
        this.refreshStepListing();
      });
    }
  }

  getStepComponent(stepName) {
    switch (stepName) {
      case layout_code.REGISTER_USCIS:
        return USCISH1BLotteryComponent;
      case layout_code.LCA_JOB_DETAIL:
        return LcaAndJobDetailsComponent;
      case layout_code.BEN_LCA_JOB_DETAIL:
        return LcaAndJobDetailsComponent;
      case layout_code.INDIVIDUAL_DETAIL:
        return IndividualsDetailsComponent;
      case layout_code.BEN_INDIVIDUAL_DETAIL:
        return IndividualsDetailsComponent;
      case layout_code.AWAIT_LOTTERY:
        return AwaitLotterySelectionComponent;
      case layout_code.OCCUPATION_DETAIL:
        return SpecialityOccupationComponent;
      case layout_code.BEN_OCCUPATION_DETAIL:
        return SpecialityOccupationComponent;
      case this.subTaskDetails.taskTypeDetails.visaType === "H1-B" &&
        layout_code.H1_B_POSITION_DETAIL:
        return H1bJobDescriptionComponent;
      case this.subTaskDetails.taskTypeDetails.visaType === "H1-B" &&
        layout_code.PETITIONER_DOCS_H1B:
        return H1bPetitionerDetailsComponent;
      case layout_code.H1B_POSITION_DETAIL:
      case layout_code.POSITION_DETAIL:
      case layout_code.BEN_POSITION_DETAIL:
      case layout_code.BEN_H1_B_POSITION_DETAIL:
        return JobDescriptionComponent;
      case layout_code.PAST_POSITION_DETAIL:
        return PastJobDescriptionComponent;
      case layout_code.BEN_PAST_POSITION_DETAIL:
        return PastJobDescriptionComponent;
      case layout_code.PERSONAL_DETAIL:
      case layout_code.BEN_PERSONAL_DETAIL:
        if (
          ["I130", "I485", "DS160", "DS260"].includes(this.paramTaskTypeCode) ||
          ["K1", "K3"].includes(this.subTaskDetails.taskTypeDetails.visaType) ||
          ["ASYLRELATIVE"].includes(
            this.subTaskDetails.taskTypeDetails.immClassificationCode
          )
        ) {
          return ProvideInformationContainerComponent;
        } else {
          return BeneficiaryPersonalDetailsComponent;
        }
      case layout_code.EDUCATION_DETAIL:
        return EducationDetailsComponent;
      case layout_code.BEN_EDUCATION_DETAIL:
        return EducationDetailsComponent;
      case layout_code.EXPERIENCE_DETAIL:
        return WorkExperienceDetailsComponent;
      case layout_code.BEN_EXPERIENCE_DETAIL:
        return WorkExperienceDetailsComponent;
      case layout_code.IMM_OTH_DOCS:
        return BeneficiaryDocumentsComponent;
      case layout_code.BEN_IMM_OTH_DOCS:
        return BeneficiaryDocumentsComponent;
      case layout_code.EMPR_EMP_REL_DETAIL:
      case layout_code.BEN_EMPR_EMP_REL_DETAIL:
        return ProvideEERComponent;
      case layout_code.PETITIONER_DOCS_FORGN:
        return PetitionerDetailsForeignCompanyComponent;
      case layout_code.PETITIONER_DOCS:
        return PetitionerDetailsComponent;
      case layout_code.BEN_PETITIONER_DOCS:
        return PetitionerDetailsComponent;
      case layout_code.PETITIONER_DOCS_H1B:
        return PetitionerDetailsComponent;
      case layout_code.PETITIONER_DOCS_US:
        return PetitionerDetailsComponent;
      // case layout_code.BEN_PROVIDE_BEN_DOCS:
      //   return BeneficiaryDocumentsComponent;
      case layout_code.USCIS_CONTENT:
      case layout_code.BEN_USCIS_CONTENT:
        return UscisContentComponent;
      case layout_code.REVIEW_PETITION:
      case layout_code.BEN_REVIEW_PETITION:
        return ReviewI140PetitionComponent;
      case layout_code.PRINT_PETITION:
      case layout_code.BEN_PRINT_PETITION:
        return PrintPetitionComponent;
      case layout_code.SUBMIT_FEES:
      case layout_code.BEN_SUBMIT_FEES:
        return SubmitPetitionComponent;
      case layout_code.GET_RECEIPT:
      case layout_code.BEN_GET_RECEIPT:
        return GetReceiptsComponent;
      case layout_code.FILL_FORM:
      case layout_code.BEN_FILL_FORM:
        return LetterGenerationComponent;
      case layout_code.UPDATE_DECISION:
        return UpdateDecisionComponent;
      case layout_code.SEND_NOTIFICATION:
        return SendNotificationComponent;
      case layout_code.UPDATE_EMPLOYMENT:
        return UpdateEmploymentComponent;
      case layout_code.IOS_DETAIL:
      case layout_code.BEN_IOS_DETAIL:
        return ItineraryOfServicesComponent;
      case layout_code.LCA:
        return LcaComponent;
      case layout_code.EXTR_ABL_DETAIL:
        return CaptureExtraordinaryAbilityDetailsComponent;
      case layout_code.BEN_EXTR_ABL_DETAIL:
        return CaptureExtraordinaryAbilityDetailsComponent;
      case layout_code.ENT_REL_DETAIL:
      case layout_code.BEN_ENT_REL_DETAIL:
        return EnterEntitiesRelationshipDetailsComponent;
      case layout_code.O_POSITION_DETAIL:
      case layout_code.BEN_O_POSITION_DETAIL:
      case layout_code.TN_POSITION_DETAIL:
      case layout_code.E_POSITION_DETAIL:
        return VdJobDescriptionComponent;
      case layout_code.O_PETITIONER_DOCS:
      case layout_code.BEN_O_PETITIONER_DOCS:
        return VdProvidePetitionerDetailsComponent;
      case layout_code.PROC_INFO:
      case layout_code.BEN_PROC_INFO:
        return EnterProcessingInformationComponent;
      case layout_code.BENEFICIARY_DETAIL:
      case layout_code.BEN_BENEFICIARY_DETAIL:
        return ProvideInformationContainerComponent;
      case layout_code.PRIMARY_APPLICANT_DETAILS:
      case layout_code.SECONDARY_APPLICANT_DETAILS:
      case layout_code.BEN_PRIMARY_APPLICANT_DETAILS:
      case layout_code.BEN_SECONDARY_APPLICANT_DETAILS:
      case layout_code.SPOUSE_DETAIL:
      case layout_code.CHILD_DETAIL:
      case layout_code.BEN_SPOUSE_DETAIL:
      case layout_code.BEN_CHILD_DETAIL:
        return VdApplicantDetailsComponent;
      case layout_code.UPDATE_DETERMINATION:
        return UpdateDeterminationComponent;
      case layout_code.BEN_EFILING:
      case layout_code.EFILING:
        return EfilingComponent;
      default:
        return CustomStepsFormComponent;
    }
  }

  refreshCustomStepListing(data: any) {    
    if (this.customStepsFromOveriew.length) {
      this.customStepsFromOveriew.forEach((custStep) => {
        if (
          (custStep.isBeneficiaryAction && custStep.isBeneficiaryVisible) ||
          custStep.isAttorneyVisible ||
          custStep.isPetitionerVisible
        ) {
          let allindex = data.filter(
            (x) => x.stepName === custStep.previousStepName
          );
          let index = data.findIndex(
            (x) => x.stepName === custStep.previousStepName
          );
          custStep["isCustomStep"] = true;
          custStep.stepPosition === "before"
            ? ""
            : (index = allindex.length > 1 ? index + 2 : index + 1);
          if (!data.find(d => d.id === custStep.id)) {
            data.splice(index, 0, custStep);
          }
        }
      });
      data = data.filter(c => !(c.isPetitionerAction && !c.isPetitionerVisible))
      this.stepList = data;
    } else {
      this.stepList = data;
    }
  }

  updateTaskAllocation(customStepListData) {
    let subtaskForm;
    //console.log("postSubTask", this.task);
    const questionAndResponseDTO =
      this.task.questionAndResponseDTO &&
        this.task.questionAndResponseDTO.length > 0
        ? this.task.questionAndResponseDTO.map((x) => {
          return {
            ...x,
            answer: x.answer ? 1 : 0,
          };
        })
        : [];
    if (
      this?.visaTypeArray?.includes(this?.task?.taskTypeDetails?.visaType) &&
      this?.taskType !== "DS160"
    ) {
      subtaskForm = {
        attorneyId: this?.task?.attorneyId,
        authorizedSignatoryId: this?.task?.signatoryDetails?.id,
        beneficiaryId: this?.task?.beneficiaryId,
        companyId: this?.task?.companyId,
        id: this?.task?.id,
        immSpecialistId: this?.task?.immSpecialistId,
        immigrantTypeCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.immigrationType
          : null,
        isOutsideImagility: this?.task?.isOutsideImagility,
        petitionTypeCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.petitionType
          : null,
        preparerAttorneyId: this?.task?.preparerAttorneyId,
        questionAndResponseDTO,
        // serviceCenterId: this?.task?.serviceCenterId,
        serviceCenterId: this?.task?.serviceCenterDetails?.id,
        superTaskId: this?.task?.superTaskId,
        superTaskTypeCode: this?.task?.superTaskTypeCode,
        taskTypeCode: this?.taskTypeCode,
        visaTypeCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.visaType
          : null,
        companyRelationCode: this?.task?.foreignCompanyRelationCode,
        foreignCompanyId: this?.task?.foreignCompanyId,
        stepList: this?.SubTaskStepList || [],
        customStepList: customStepListData || [],
      };
    } else if (
      this?.OVisaTypeArray?.includes(this?.task?.taskTypeDetails?.visaType) &&
      this?.taskType !== "DS160"
    ) {
      subtaskForm = {
        id: this?.task?.id,
        attorneyId: this?.task?.attorneyId,
        authorizedSignatoryId: this?.task?.signatoryDetails?.id,
        beneficiaryId: this?.task?.beneficiaryId,
        companyId: this?.task?.companyId,
        immSpecialistId: this?.task?.immSpecialistId,
        immigrantTypeCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.immigrationType
          : null,
        isOutsideImagility: this?.task?.isOutsideImagility,
        petitionTypeCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.petitionType
          : null,
        preparerAttorneyId: this?.task?.preparerAttorneyId,
        questionAndResponseDTO,
        //  serviceCenterId: this?.task?.serviceCenterId,
        serviceCenterId: this?.task?.serviceCenterDetails?.id,
        superTaskId: this?.task?.superTaskId,
        superTaskTypeCode: this?.task?.superTaskTypeCode,
        visaTypeCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.visaType
          : null,
        extrAblDocEvdCatgCode: this?.task?.extrAblDocEvdCatg?.code,
        fieldExtrAbltyCode: this?.task?.fieldExtrAblty?.code,
        applicableOptionCodes: this?.task?.extrAblDocEvdList,
        stepList: this?.SubTaskStepList || [],
        customStepList: customStepListData || [],
        taskTypeCode: this?.taskTypeCode,
      };
    } else if (this?.taskType === "I130") {
      subtaskForm = {
        attorneyId: this?.task?.attorneyId,
        authorizedSignatoryId: this?.task?.signatoryDetails
          ? this?.task?.signatoryDetails?.id
          : null,
        beneficiaryId: null,
        companyId: null,
        id: this?.task?.id,
        immSpecialistId: this?.task?.immSpecialistId,
        immigrantTypeCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.immigrationType
          : null,
        isOutsideImagility: this?.task?.isOutsideImagility,
        petitionTypeCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.petitionType
          : null,
        preparerAttorneyId: this?.task?.preparerAttorneyId,
        questionAndResponseDTO,
        serviceCenterId: this?.task?.serviceCenterDetails?.id,
        superTaskId: this?.task?.superTaskId,
        superTaskTypeCode: "IMMPET",
        taskTypeCode: this?.taskType,
        visaTypeCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.visaType
          : null,
        familyId: this?.task?.familyId,
        immCategoryCode: this?.superTask?.immigrationCategory
          ? this?.superTask?.immigrationCategory?.code
          : null,
        immClassificationCode: this?.superTask?.immigrationClassification
          ? this?.superTask?.immigrationClassification?.code
          : null,
        sponsorId: this?.task?.sponsorId,
        stepList: this?.SubTaskStepList || [],
        customStepList: customStepListData || [],
      };
    } else {
      subtaskForm = {
        attorneyId: this?.task?.attorneyId,
        authorizedSignatoryId: this?.task?.signatoryDetails
          ? this?.task?.signatoryDetails?.id
          : null,
        beneficiaryId: this?.task?.beneficiaryId,
        companyId: this?.task?.companyId,
        id: this?.task?.id,
        immSpecialistId: this?.task?.immSpecialistId,
        immigrantTypeCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.immigrationType
          : null,
        isOutsideImagility: this?.task?.isOutsideImagility,
        petitionTypeCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.petitionType
          : null,
        preparerAttorneyId: this?.task?.preparerAttorneyId,
        questionAndResponseDTO,
        // serviceCenterId: this?.task?.serviceCenterId,
        superTaskId: this?.task?.superTaskId,
        superTaskTypeCode: this?.task?.superTaskTypeCode,
        taskTypeCode: this?.taskTypeCode,
        visaTypeCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.visaType
          : null,
        immCategoryCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.immCategoryCode
          : null,
        immClassificationCode: this?.task?.taskTypeDetails
          ? this?.task?.taskTypeDetails?.immClassificationCode
          : null,
        companyRelationCode: this?.task?.foreignCompanyRelationCode,
        foreignCompanyId: this?.task?.foreignCompanyId,
        taskTypeId: this?.task?.taskTypeId,
        stepList: this?.SubTaskStepList || [],
        customStepList: customStepListData || [],
      };
    }
    subtaskForm.customStepList.map((step) => {
      let isUpdate = this.customQuestionnaireService.masterData.customStepList.find(s => s.id === step.stepId);
      if (isUpdate) {
        step.taskStepId = step.stepId;
      }
    });
    this.saveUpdateSubTask(subtaskForm, this.taskType);
  }

  saveUpdateSubTask(subtaskForm, taskType) {
    this.customQuestionnaireService
      .saveUpdateSubTask(subtaskForm, taskType)
      .pipe(take(1))
      .subscribe((response: ImagilityBaseResponse) => {
        if (response && response.status === 200) {
          // this.toastr.success(response.message);
          // Get Step list
          this.store
            .pipe(select(getSubTaskStepList))
            .pipe(take(1))
            .subscribe((data: TaskStep[]) => {
              if (data) {
                this.taskAllocationUpdated = true;
                this.refreshStepListing();
              }
            });
          // Get Step list
        }
      });
  }

  refreshStepListing() {
    this.petitionerService
      .getSuperTask(this.superTask.superTaskId)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: TaskSummaryOverview) => {
        if (data && data.subTaskList) {
          this.store.dispatch(new Task.SetTaskSummaryOverview(data));
          const subTask = data.subTaskList.find(
            (task: SubTask) => task?.id === this.subTaskDetails?.id
          );
          if (subTask) {
            this.customStepsFromOveriew = subTask.customStepOverviewList
              ? subTask.customStepOverviewList
              : [];
            // if (this.customStepsFromOveriew.length !== this.customQuestionnaireService.masterData.customStepList.length){this.taskAllocationUpdateRequired = true}else{this.taskAllocationUpdateRequired = false};
            this.store.dispatch(
              loadSubTaskDetails({
                taskId: parseInt(subTask?.id.toString()),
                // visaTypeCode: this.route.snapshot.paramMap.get(this.paramPresent)
                visaTypeCode:
                  this.superTaskTypeCode === "NONIMMPET"
                    ? this.superTask.visaType.code
                    : this.taskTypeCode,
              })
            );
          }
        }
      });
  }

  checkForTaskAllocationUpdate(data) {
    let companyId: any =
      this.subTaskDetails.createdByUserType === "Attorney"
        ? this.subTaskDetails.attorneyId
        : this.subTaskDetails.companyId;
    sessionStorage.setItem("companyId", companyId);
    let userType = localStorage.getItem("userTypeRole");
    if (userType === "Beneficiary") {
      localStorage.setItem("cqCompanyId", companyId);
    }
    this.customQuestionnaireService
      .getCustomStepsDetails(companyId, this.subTaskDetails.taskTypeId)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((cqData: any) => {
        this.customQuestionnaireService.masterData = cqData;
        if (this.customStepsFromOveriew.length !== cqData.customStepList.length) {
          let mergedData;
          if (this.subTaskDetails.taskCustomStepDetails.length) {

            const stepIDSet = new Set(
              this.subTaskDetails.taskCustomStepDetails.map((item) => item.stepId)
            );
            const masterData = cqData.customStepList.filter(
              (item) => !stepIDSet.has(item?.id)
            );
            mergedData = [...this.subTaskDetails.taskCustomStepDetails, ...masterData];
          } else {
            mergedData = cqData.customStepList;
          }

          // let isDuplicateCustomSteps: any =
          //   this.removeDuplicatesByProperty(
          //     this.subTaskDetails.taskCustomStepDetails,
          //     "stepName"
          //   );

          // isDuplicateCustomSteps = (isDuplicateCustomSteps.length) * 2 < this.subTaskDetails.taskCustomStepDetails.length;

          this.updateTaskAllocation(mergedData);
        } else {
          this.customQuestionnaireService
            .updateNotificationSettings(this.task?.id)
            .subscribe((cqData: any) => {
            });
          this.refreshCustomStepListing(data);
        }
      });
  }

  ngAfterViewInit() {
    this.translet();    
  }
  translet(){
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);  
  }

  ngOnDestroy() {
    sessionStorage.removeItem("isSimplify");
    sessionStorage.removeItem("noteCompanyId");
    if (this.dynamicDialogRef) {
      this.dynamicDialogRef.close();
    }
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    this.observableSubscription$?.unsubscribe();
    //this.lookupService.isBeneficiaryInitiate.unsubscribe();
  }

}
